import { useState } from "react";
import Box from "@mui/material/Box";
import AutocompleteField from "../../../../components/Form/AutocompleteField";
import Chip from "@mui/material/Chip";
import PublicIcon from "@mui/icons-material/Public";
import CardContainer from "../../../../components/Card/CardContainer";
import SectionHeader from "./SectionHeader";
import { COUNTRIES } from "../../../../utils/constants";
import {
  SECTION_COUNTRY_TITLE,
  SECTION_COUNTRY_SUBTITLE,
  SECTION_COUNTRY_LABEL,
  SECTION_COUNTRY_DEFAULT_VALUE,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";

const isKnownCountry = (value) => COUNTRIES.some((opt) => opt.value === value);

export const CountrySection = ({ formMethods, hasError = false }) => {
  const { t } = useTranslationApp();
  const [isEditing, setIsEditing] = useState(false);

  const businessCountry = formMethods?.watch?.("businessCountry") || "";

  if (!formMethods || !formMethods.control) {
    return null;
  }

  const { control, errors, validationRules } = formMethods;

  const getCountryLabel = () => {
    if (!businessCountry || !isKnownCountry(businessCountry)) {
      return t(SECTION_COUNTRY_DEFAULT_VALUE);
    }
    const option = COUNTRIES.find((opt) => opt.value === businessCountry);
    return option ? t(option.label) : t(SECTION_COUNTRY_DEFAULT_VALUE);
  };

  const onSave = () => {
    setIsEditing(false);
  };

  const onEdit = async () => {
    setIsEditing(true);
    await formMethods.trigger?.(["businessCountry"]);
  };

  return (
    <CardContainer title="" hasError={hasError}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          minHeight: "100%",
        }}
      >
        <SectionHeader
          icon={PublicIcon}
          title={SECTION_COUNTRY_TITLE}
          subtitle={SECTION_COUNTRY_SUBTITLE}
          isEditing={isEditing}
          onEdit={onEdit}
          onSave={onSave}
        />

        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              display: isEditing ? "flex" : "none",
              flexDirection: "column",
              gap: 2,
              flex: 1,
            }}
          >
            <Box>
              <AutocompleteField
                control={control}
                name="businessCountry"
                rules={validationRules.businessCountry}
                errors={errors}
                options={COUNTRIES}
                doTranslate
                fullWidth
                variant="filled"
                label={t(SECTION_COUNTRY_LABEL)}
                placeholder={t(SECTION_COUNTRY_DEFAULT_VALUE)}
              />
            </Box>
          </Box>

          {!isEditing && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                flex: 1,
              }}
            >
              <Chip
                label={getCountryLabel()}
                sx={{
                  alignSelf: "flex-start",
                  backgroundColor: "#F5F5F5",
                  color: "text.primary",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  px: 2,
                  py: 1.5,
                  height: "auto",
                }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </CardContainer>
  );
};

export default CountrySection;
